import api from './api';
import { AppType, Zeitslot } from '../types';
import { datumToDateKey, toDateKey } from '../utils/dateUtils';

export const scheduleService = {
    // Default Schedules
    getDefaultSchedules: async (app: AppType) => {
        const response = await api.get('/default-schedules', { params: { app } });
        return response.data;
    },

    createDefaultSchedule: async (data: { arztId: number; praxisId: number; dayOfWeek: string; zeitslot: Zeitslot; app: AppType }) => {
        const response = await api.post('/default-schedules', data);
        return response.data;
    },

    deleteDefaultSchedule: async (id: number) => {
        await api.delete(`/default-schedules/${id}`);
    },

    // Effective Schedule
    getEffectiveSchedule: async (params: { app: AppType; startDatum: Date; endDatum: Date; praxisId?: number; arztId?: number }) => {
        // Send calendar days, not instants: the API derives the weekday from them.
        const response = await api.get('/default-schedules/effective', {
            params: {
                ...params,
                startDatum: toDateKey(params.startDatum),
                endDatum: toDateKey(params.endDatum),
            }
        });
        return response.data;
    },

    // Overrides
    createOverride: async (data: { arztId: number; praxisId?: number; datum: Date | string; zeitslot: Zeitslot; app: AppType; isCancelled?: boolean }) => {
        const response = await api.post('/schedule-overrides', { ...data, datum: datumToDateKey(data.datum) });
        return response.data;
    },

    deleteOverride: async (id: number) => {
        await api.delete(`/schedule-overrides/${id}`);
    }
};
